import React, { useCallback } from 'react';
import * as dealAuditLogActionCreators from '@makemydeal/dr-dash-store/actions/dealAuditLogActionCreators';
import * as dealAuditLogSelectors from '@makemydeal/dr-dash-store/selectors/dealAuditLogSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { PrinterIcon } from '@interstate/components/Icons';
import { Spinner } from '@interstate/components/Spinner';

/**
 * PrintAuditLog component renders a printer icon that, when clicked,
 * initiates the download of the audit log for a specific version.
 * It shows a spinner while the download is in progress.
 *
 * @param {Object} props - Component properties
 * @param {string} props.version - The version of the audit log to download
 */
interface PrintAuditLogProps {
    version: string;
}

const PrintAuditLog: React.FC<PrintAuditLogProps> = ({ version }) => {
    const dispatch = useDispatch();
    const downloadingVersionId = useSelector(dealAuditLogSelectors.getDownloadingVersion);
    const downloadHandler = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation(); // Prevent row click event
            dispatch(dealAuditLogActionCreators.startDownloadSpinner(version));
            dispatch(dealAuditLogActionCreators.downloadAuditLog());
        },
        [dispatch, version]
    );

    return downloadingVersionId === version ? <Spinner size={24} /> : <PrinterIcon onClick={downloadHandler} fontSize={16} />;
};

export default PrintAuditLog;
